import { render, staticRenderFns } from "./ArticleMentionNotificationContent.vue?vue&type=template&id=f7781b76&"
import script from "./ArticleMentionNotificationContent.vue?vue&type=script&lang=ts&"
export * from "./ArticleMentionNotificationContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports